import {State} from "./types";

export const initialState: State = {
  assets: [],
  shown: false,
};
